import { localStorageKey } from '@/i18n/i18n.config';

export function getPreferredLocale(supportedLocales) {
  // Check the localStorage first, this has priority
  if (
    localStorage.getItem(localStorageKey)
    && supportedLocales.includes(localStorage.getItem(localStorageKey))
  )
  {
    return localStorage.getItem(localStorageKey);
  }

  let browserLocale = '';

  if (navigator.languages.length) {
    // Loop over browser languages to find the first language that matches a translation file
    browserLocale = navigator.languages.find((language) => {
      // Try and find a matching locale (browser locales use hyphens instead in underscores so we replace those)
      // E.g. the browser uses en-US while we have en_US
      return supportedLocales.includes(language.replace('-', '_'));
    });
  } else if (navigator.language) {
    browserLocale = supportedLocales.find((language) => {
      return language === navigator.language.replace('-', '_');
    });
  }

  return browserLocale;
}
